import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["input", "decreaseNumber", "increaseNumber", "numberValue"]
  static values = { digit: String };

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('keypress', this._validateKeypress.bind(this))
      this.inputTarget.addEventListener('input', this._validateInput.bind(this))
    }
  }

  _validateKeypress(event) {
    const allowedChars = this.digitValue == 0 ? /^[0-9]$/ : /^[0-9.]$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  _validateInput(event) {
    const value = event.target.value
    const allowedDigit = new RegExp(`/^\d*\.?\d{0,${this.digitValue || 2}}$/`);
    if (!allowedDigit.test(value) && value.includes('.')) {
      event.target.value = this._sanitizeValue(value);
    }
  }

  _sanitizeValue(value) {
    const parts = value.split('.');
    return `${parts[0]}.${parts[1].slice(0, this.digitValue || 2)}`;
  }

  increase() {
    const value = parseInt(this.numberValueTarget.value, 10) || 0
    this.numberValueTarget.value = value + 1
  }

  decrease() {
    const value = parseInt(this.numberValueTarget.value, 10) || 0
    if (value > 0) {
      this.numberValueTarget.value = value - 1
    }
  }
}
